import React from 'react'
import { ITwoCol } from './types'

export const TwoCol = ({ children, className = '' }: ITwoCol) => {
    return (
        <div className={`grid gap-y-4 md:grid-cols-2 md:gap-y-0 md:gap-x-8 lg:gap-x-12 xl:gap-x-16 ${className}`}>
            {children[0]}
            {children[1]}
        </div>
    )
}

export default TwoCol
